import { SelectableTable } from "@ext/enterprise/components/admin/ui-kit/table/SelectableTable";
import type { useUserAccessPickerDialogContent } from "@ext/enterpriseCommon/hooks/useUserAccessPickerDialogContent";
import t from "@ext/localization/locale/translate";
import type { RowSelectionState } from "@ui-kit/DataTable";
import type { Dispatch, ReactNode, SetStateAction } from "react";

type UserAccessPickerDialogTableProps = {
	data: ReturnType<typeof useUserAccessPickerDialogContent>["data"];
	headerLeftControls: ReactNode;
	selection: RowSelectionState;
	setSelection: Dispatch<SetStateAction<RowSelectionState>>;
	toolbarActions: ReactNode;
};

export const UserAccessPickerDialogTable = (props: UserAccessPickerDialogTableProps) => {
	const { data, headerLeftControls, selection, setSelection, toolbarActions } = props;

	return (
		<div className="flex h-full flex-col gap-2">
			{data.ssoEnabled && (
				<span className="text-sm text-muted">{t("enterprise.admin.users.use-search-for-sso")}</span>
			)}
			<SelectableTable
				className="flex flex-col min-h-0"
				columns={data.columns}
				data={data.rows}
				getRowId={data.getRowId}
				isLoading={data.isLoading}
				onRowSelectionChange={setSelection}
				onSearchChange={data.filter.query.set}
				rowSelection={selection}
				rowVersions={data.rowVersions}
				searchPlaceholder={
					data.ssoEnabled ? t("enterprise.admin.users.find") : t("enterprise.admin.users.find-by-email")
				}
				toolbarActions={toolbarActions}
				toolbarLeftActions={headerLeftControls}
			/>
		</div>
	);
};
